import { WTooltip } from "@/components/WTooltip.tsx";
import { WButton } from "@/components/button/WButton.tsx";
import { getResourceLink, type AnyResource } from "@/modules/api/resourceTypes.tsx";
import { useLingui } from "@lingui/react/macro";

export function ResourceLink({ title, item }: { title?: string; item: AnyResource }) {
    const { t } = useLingui();
    const action = getResourceLink(item);

    return (
        <WTooltip text={t({ comment: "Button action", message: "View" })}>
            <WButton action={action} size="xs" color="primary" variant="ghost">
                {title}
            </WButton>
        </WTooltip>
    );
}
